<template>
    <div class=" drop-shadow group rounded relative z-[1000]" :class="t=='fosc'?'bg-black/40 text-white':'hover:bg-gray-200 bg-white text-black'">
        <div class="absolute w-full z-[-1] p-2 border-b-2 leading-1 justify-end flex "
        :class="t=='fosc'?'bg-black/20':'bg-gray-100 group-hover:bg-gray-200 '"
        :style="{borderColor: colles[mostra].codi_color}">
        <div class="w-2/3 opacity-0">
            <h2 class=""><strong>{{ colles[mostra].nom }}</strong>{{ " " }}
                        <IcoTipEst  :key="colla" :colla="colla" dada="tipus"/>{{ " " }}
                        <IcoTipEst  :key="colla" :colla="colla" dada="estat"/>
                    </h2>
                    <em class="text-sm" v-for="(malnom,index) in colla.malnoms" :key="index">{{ malnom }}<span v-if="index<colla.malnoms.length-1">, </span> </em>
            
        </div></div>
        <div class=" w-full p-2 flex" >
        <div class="w-1/3 pr-2">
            <QuadreColla :key="colles[mostra].id" class="border-[3px] border-white drop-shadow" :obj="colles[mostra]" :tippy=false :link="'/' + colla.llista + '/' + colla.id"/>
                <div class="" :class="t=='fosc'?'':'bg-white group-hover:bg-gray-200'">
                    <div class="text-sm"><strong>Camisa: </strong>{{ colles[mostra].color_camisa }}</div>
                    <div :class="t=='fosc'?'text-white/80':'text-black/60'">
                        <div class="text-xs" v-if="colles[mostra].pantone"><strong>Pantone: </strong>{{ colles[mostra].pantone }}</div>
                        <div class="text-xs"><strong>HEX: </strong>{{ colles[mostra].codi_color }}</div>
                        <div class="text-xs"><strong>RGB: </strong>{{ colles[mostra].color_rgb[0]+','+colles[mostra].color_rgb[1]+','+colles[mostra].color_rgb[2] }}</div>
                        <div class="text-xs"><strong>HSL: </strong>{{ colles[mostra].color_hsl[0]+','+colles[mostra].color_hsl[1]+','+colles[mostra].color_hsl[2] }}</div>
                        <div class="text-xs" v-if="colles[mostra].color_cmyk?.length"><strong>CMYK: </strong>{{ colles[mostra].color_cmyk[0] }}</div>
                    </div> </div>
        </div>
            <div class="w-2/3 class flex flex-col gap-3">
                <router-link :to="'/' + colla.llista + '/' + colla.id" >
                    <h2><strong>{{ colles[mostra].nom }}</strong>{{ " " }}
                        <IcoTipEst :key="colla" :colla="colla" dada="tipus"/>{{ " " }}
                        <IcoTipEst :key="colla" :colla="colla" dada="estat"/>
                    </h2>
                    <em class="text-sm" v-for="(malnom,index) in colla.malnoms" :key="index">{{ malnom }}<span v-if="index<colla.malnoms.length-1">, </span> </em>
                </router-link>
        <div class="text-sm flex gap-2">
            <div class="w-full">
                <p><strong>Localitat: </strong>{{ colla.localitat }}</p>
                
                <p><strong>Tipus: </strong>{{ Format(colla.tipus).singular }}</p>
                
                <p><strong>Estat: </strong>{{ Format(colles[mostra].estat).singular }}</p>

                <p v-if="colles?.length>1"><strong>Fundació original: </strong>{{ colla.fundacio_original }}</p>
                <p v-if="colles[mostra]!=colles[0]"><strong>Refundació: </strong>{{ colles[mostra].fundacio }}</p>
                <p v-else><strong>Fundació: </strong>{{ colla.fundacio_original }}</p>
                
                <p v-if="colles[mostra].estat=='desapareguda'"><strong>Desaparició: </strong>{{ colles[mostra].desaparicio }}</p>
            </div>
            <div class="w-fit flex flex-col text-xl items-center">
                <a class=" opacity-70 hover:opacity-100" 
                        title="Pàgina Web de la Colla" v-if="colla.web!==null" 
                        :href="'https://'+colla.web" 
                        target="_blank" alt="Pàgina Web de la Colla">
                            <font-awesome-icon :icon="['fas','globe']"/>
                    </a>
                    <a  v-if="colla.instagram!==null" 
                        title="Pàgina d'Instagram de la Colla"
                        alt="Pàgina d'Instagram de la Colla"
                        class=" opacity-70 hover:opacity-100"
                        :href="'https://www.instagram.com/'+colla.instagram" target="_blank">
                        <font-awesome-icon :icon="['fab', 'instagram']"/>
                    </a>
                    <a  v-if="colla.twitter!==null" 
                        title="Pàgina de Twitter de la Colla"
                        alt="Pàgina de Twitter de la Colla"
                        class=" opacity-70 hover:opacity-100"
                        :href="'https://www.x.com/'+colla.twitter" target="_blank">
                        <font-awesome-icon :icon="['fab', 'x-twitter']"/>
                    </a>
                    <a  v-if="colla.facebook!==null" 
                        title="Pàgina de Facebook de la Colla"
                        alt="Pàgina de Facebook de la Colla"
                        class=" opacity-70 hover:opacity-100"
                        :href="'https://www.facebook.com/'+colla.facebook" target="_blank">
                        <font-awesome-icon :icon="['fab', 'facebook']"/>
                    </a>
                    <a  v-if="colla.youtube!==null" 
                        title="Pàgina de YouTube de la Colla"
                        alt="Pàgina de YouTube de la Colla"
                        class=" opacity-70 hover:opacity-100"
                        :href="'https://www.youtube.com/@'+colla.youtube" target="_blank">
                        <font-awesome-icon :icon="['fab', 'youtube']"/>
                    </a>
                    
                      <a title="Article Wikipedia de la Colla"
                        alt="Article Wikipedia de la Colla"
                        class="opacity-70 hover:opacity-100"
                        :href="colla.wikipedia!==null?'https://ca.wikipedia.org/w/index.php?title='+colla.wikipedia:'https://ca.wikipedia.org/w/index.php?title='+colla.nom+'&action=edit&redlink=1'" target="_blank">
                        <font-awesome-icon :icon="['fab', 'wikipedia-w']"/></a>
            </div>
        </div>  
            </div> 
        
        </div>
        <div v-if="colles?.length>1"  class="flex mx-auto justify-center gap-1 px-3 pb-2">
            <button v-for="(colla,index) in colles" :key="index" class="flex flex-col items-center hover:bg-white/20 p-1 rounded-sm" @mousedown.prevent="mostra=index">
            <div :style="{backgroundColor:colla.codi_color}" class="aspect-square h-6 border-solid border border-1 self-center" :title="colla.nom"></div>
            <span class="text-xs font-bold">{{ colla.fundacio }}</span>
        </button>
        </div>
        <div class="hidden m-2 relative h-2">
            <Timeline class="outline-white outline outline-1" :tippy=false :compacte=true :colla="colla" :origen="colla.fundacio-100" />
        </div>
        </div>
</template>

<script setup>
import {defineProps,ref,onMounted,computed} from 'vue'
import QuadreColla from './QuadreColla.vue'
import IcoTipEst from './IcoTipEst.vue'
import Timeline from './Timeline.vue'
import Format from '@/functions/formatTipEst.js'

const props = defineProps({
    colla:{
        type:Object,
        required:true
    },
    tema:{
        type:String,
        required:false,
        default:"clar"
    }
})
let mostra=ref(0)
const colles = computed(()=>{
        const muntat = []
        if (props.colla.predecesores?.length){
            muntat.push(...props.colla.predecesores)
            muntat.push(props.colla)
            
            return muntat
        }
        else{
            muntat.push(props.colla)
            return muntat
        }
    })

    if (colles.value!==null) mostra.value=colles.value.length-1

const t =ref(props.tema)
const colla=ref(props.colla)

function fundacioOriginal(perfil){
perfil.fundacio_original = Math.min(
perfil.fundacio,
...(perfil.predecesores || []).map(c => c.fundacio)
)
}

onMounted(()=>{
    if(props.colla)fundacioOriginal(props.colla)
})

</script>